module.exports = __webpack_public_path__ + "static/media/tn.e821cf63.svg";